import React from 'react'
import { Footer, Header } from '../index';
import { Link } from 'react-router-dom';
import './LazharHamel.css' ;
import Image from "../../asserts/images/lazhar.png" ;

function LazharHamel() { 
  return (
    <>
        <Header/>

        <div className='containerEnseignants'>
        <div className='bgEnseignants'>  </div>
        <div className='ligne'>  </div>
        <div className="container-fluid text-white text-center" style={{ position: 'relative', marginTop: '-287px', marginBottom: '200px' }}>
          <h1 style={{fontFamily:'fantasy', fontSize:'70px'}}className="container-fluid text-white text-center ">Enseignants</h1>
          <p ><Link className='linkEnseignants' to="/">Accueil</Link> <span>{'>'}</span><Link className='linkEnseignants'
            to="/"> ISIMM </Link>  <span>{'>'}</span> <Link className='linkEnseignants'
            to="/">Enseignants</Link> </p></div>
      </div>

        <div className='contentEnseignant1'>
          
            <div className="cardEnseignant">
                            <img src={Image}></img>

             </div>
             <div className='discriptionEnseignant'>
                <p className='nomdepartement'> <Link to="/Lazhar hamel" style={{fontFamily:'fantasy' , color:'#162533'}} >Directeur du Département d'Informatique </Link></p>
                <p style={{    fontFamily: 'Poppins, sans-serif ' }}>Lazhar Hamel</p>
               <div className='divemail'>
                    <i class="fa-regular fa-envelope"></i> 
                    <p id='email1'>mailto:lazhar.hamel@gmail.com</p>
                </div> 

             </div>
        </div>
        <Footer/>
    </>
    
  )
}

export default LazharHamel